import { AxiosResponse } from "axios";
import { getApi } from "./resonanceApi";

/**
 * Subject "Calendrier" — the current user's own not-yet-open questionnaire
 * windows. UNCACHED on purpose (suivi.service pattern): the page refetches on
 * every tab entry. Open questionnaires and recurrent next-occurrences are NOT
 * fetched here — they already live in ResonanceDataContext (sequences +
 * sequenceAvailabilityBySequenceId).
 */

export enum CalendarUrlsEnum {
  GET_UPCOMING_WINDOWS = "studies/{studyId}/users/current/upcoming_windows",
}

export interface CalendarUpcomingWindow {
  sequence_id: number;
  label: string | null;
  opens_at: string;
  closes_at: string;
  // Whom the window is about — equals the current user for their own windows; another
  // family member's id for parent-about-child windows (optional: older API payloads
  // may omit both fields).
  subject_user_id?: number;
  // «Emma» / «Enfant 2» — null for the user's own windows.
  subject_label?: string | null;
}

export interface CalendarUpcomingResponse {
  upcoming: CalendarUpcomingWindow[];
}

export const getUpcomingWindows = ({
  studyId,
  lang,
}: {
  studyId: number;
  lang: string;
}): Promise<AxiosResponse<CalendarUpcomingResponse>> =>
  getApi<CalendarUpcomingResponse>(CalendarUrlsEnum.GET_UPCOMING_WINDOWS, { studyId }, { lang });
